import React from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "../../lib/msal-react";
import { msalConfig } from "./microsoftAuthConfig";
import { SignInButton } from "./MicrosoftAuth/SignInButton";

const msalInstance = new PublicClientApplication(msalConfig);

export const LoginContainer = styled.div`
   {
    width: 350px;
    height: 350px;
    border-top: 4px solid red !important;
    box-shadow: 3px 3px 5px 1px rgba(170, 170, 170, 0.8);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -175px;
    background-color: #ffffff;
  }
`;

const Login = ({ handleAuthClickMicrosoft }) => {
  return (
    <div className="p-login p-al-r-full-center">
      <div className="p-login-item p-content-item p-al-c-full-center">
        <img src="/img/logo_upsell_login.png" />
        <MsalProvider instance={msalInstance}>
          <SignInButton handleAuthClickMicrosoft={handleAuthClickMicrosoft}/>
        </MsalProvider>
      </div>
    </div>
  );
};

export default withRouter(Login);



// WEBPACK FOOTER //
// src/components/login/index.js